import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useCallback, useEffect, useState } from 'react';
import styles from './styles/CustomScroll.module.scss';

type Props = {
  wrapperId: string;
  tableId: string;
  changeGradientPosition: (value) => void;
};

const CustomScroll = ({ wrapperId, changeGradientPosition, tableId }: Props) => {
  const [scrollValue, setScrollValue] = useState(-15);
  const [maxValue, setMaxValue] = useState(0);

  const handleScroll = useCallback(
    (value) => {
      const currentYPosition = window.scrollY;
      const table = document.getElementById(wrapperId);
      if (table && currentYPosition) {
        table.scroll(+value, currentYPosition);
      }
      setScrollValue(+value);
      if (value >= maxValue) {
        changeGradientPosition('gradient-left');
      }
      if (value <= 0) {
        changeGradientPosition('gradient-right');
      }
    },
    [maxValue, changeGradientPosition, wrapperId]
  );

  useEffect(() => {
    const element = document.getElementById(tableId);
    const leftPagePadding = document.getElementById(wrapperId);

    if (element && leftPagePadding) {
      setMaxValue(element.offsetWidth - leftPagePadding.offsetWidth);
    }
  }, [tableId, wrapperId]);

  return (
    <div className={`${styles['custom-scroll']} mt-3`}>
      <input
        type="range"
        min="-15"
        max={maxValue}
        aria-label="table scroll range"
        value={scrollValue}
        onInput={(event) => handleScroll(event.target.value)}
      />
      <AbrdnButton
        className={`${styles['custom-scroll__button']} me-2 ${
          scrollValue === -15 ? 'disabled' : ''
        }`}
        aria-label="scroll left"
        role="button"
        onClick={() => handleScroll(scrollValue - 15)}
      >
        <i className="bi-chevron-left" aria-hidden="true" />
      </AbrdnButton>
      <AbrdnButton
        className={`${styles['custom-scroll__button']} ${
          scrollValue >= maxValue ? 'disabled' : ''
        }`}
        aria-label="scroll right"
        role="button"
        onClick={() => handleScroll(scrollValue + 15)}
      >
        <i className="bi-chevron-right" aria-hidden="true" />
      </AbrdnButton>
    </div>
  );
};

export default CustomScroll;
